import { httpInterceptor } from "@/core/services/middleware/HttpInterceptor";
import type { HttpClient } from "@/core/services/protocols/types";
import { IDefaultContabilResponse } from "../../types";
import * as types from "../requests/types";
import { ISharedGateway } from "./SharedGateway";
import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";
import Diagnostico, { IDiagnosticoResponse } from "./Diagnostico";

@injectable()
export default class SharedHttpGateway implements ISharedGateway {
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async getDiagnostico(params: types.IDiagnosticoParams): Promise<Diagnostico> {
    const response = await this.httpClient.post<
      IDefaultContabilResponse<IDiagnosticoResponse>
    >({
      url: "v1/diagnostico/list_status",
      body: { ...params }
    });

    const diagnostico = new Diagnostico(response.body?.result);

    return diagnostico;
  }

  @httpInterceptor()
  async getEmpresas(
    params: types.IEmpresaParams
  ): Promise<types.IEmpresaResponse[]> {
    const response = await this.httpClient.post<
      IDefaultContabilResponse<types.IEmpresasListResponse>
    >({
      url: "v1/contabil/empresa/list",
      body: { ...params }
    });

    // const empresa = new Empresa(response.body?.result)
    return response.body?.result.empresas || [];
  }
}
